/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Annotations} from "plotly.js";

const DEFAULT_SCATTER_PLOT_ANNOTATION: Partial<Annotations> = {
  text: "* Data is sampled to max 100,000 points across selected objects for each type of data.",
  x: -0.22,
  y: 1.23,
  xref: 'paper',
  yref: 'paper',
  xanchor: 'left',
  yanchor: 'bottom',
  showarrow: false,
  font: {
    color: 'red', // Set the color here
    size: 10 // Adjust the font size here
  }
}

const VAR_COMMON_CONSTANTS = {

    VAR_DATA_SETS:'Data Sets',
    VAR_DATA_SET:'Data Set',
    VAR_FOLDER: "Folder",
    VAR_FORBIDDEN_CHARS:/[\\/:*?"<>|']/,
    VAR_FORBIDDEN_CHARS_MSG:"Forbidden: \\/:*?\"<>|' Please enter valid input",
    LIDAR: 'LiDAR',
    ULTRASONIC: 'Ultrasonic',

    COVERAGE_PLOTS_RANGE_BUFFER: 1.25, // Matches what is set in static report in backend (see 'limit' used in matplotlib.pyplot.xlim in html_report_generation.py -> return_html_scatter_plot: "matplotlib.pyplot.xlim((-1*limit,limit))")

    plots: {
      scatterPlot: {
        DEFAULT_ANNOTATION: DEFAULT_SCATTER_PLOT_ANNOTATION
      }
    },

    sensorApp: {
        all: {
            SENSOR_TESTING_CONDITIONS_HEADER: 'Sensor Testing Conditions',
        }
    }
}

export const enum SENSOR_TYPES {
    CAMERA = 'Camera',
    RADAR = 'Radar',
    LIDAR = 'Lidar',
    ULTRASONIC = 'Ultrasonic',
}

export const ARGOS_TEST_FRONTEND_DOMAIN = 'https://argos-dev.t1.ultifi.azure.ext.gm.com'
export const ARGOS_RELEASE_FRONTEND_DOMAIN = 'https://argos-release.t1.ultifi.azure.ext.gm.com'
export const ARGOS_PROD_FRONTEND_DOMAIN = 'https://argos-release.p1.ultifi.azure.ext.gm.com'

export default VAR_COMMON_CONSTANTS